<div
  class="fb-layout"
  #layoutContainer
  [class.resizing]="isResizing"
  [style.height.px]="layoutHeight">
  <div class="fb-layout__canvas" [style.width]="canvasWidth">
    <ng-content select="[canvas]"></ng-content>
  </div>

  <div
    class="fb-layout__divider"
    *ngIf="!sidebarCollapsed"
    irembogovRealtimeResize
    irembogovRealtimeResizeTargetSelector=".fb-layout__sidebar"
    irembogovRealtimeResizeContainerSelector=".fb-layout"
    irembogovRealtimeResizeCompanionSelector=".fb-layout__canvas"
    irembogovRealtimeResizeUnit="%"
    irembogovRealtimeResizeEdge="left"
    irembogovRealtimeResizeActiveClass="resizing"
    [irembogovRealtimeResizeValue]="sidebarWidth"
    [irembogovRealtimeResizeMin]="sidebarMin"
    [irembogovRealtimeResizeMax]="sidebarMax"
    [irembogovRealtimeResizeCompanionGapPx]="dividerWidth"
    (irembogovRealtimeResizeStarted)="onResizeStart()"
    (irembogovRealtimeResizeCommitted)="onResizeCommitted($event)"
    (dblclick)="onDividerDblClick()">
    <div class="fb-layout__divider-line"></div>
  </div>

  <div
    class="fb-layout__sidebar"
    [class.collapsed]="sidebarCollapsed"
    [class.compact]="isCompact"
    [style.width]="sidebarWidthStyle">
    <ng-content select="[sidebar]"></ng-content>
  </div>

  <button
    *ngIf="sidebarCollapsed"
    class="fb-layout__expand-btn"
    (click)="onDividerDblClick()"
    title="Expand sidebar">
    <i class="fa-solid fa-chevron-left"></i>
  </button>
</div>
